function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGraphPlaceholderLong = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 786 300",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 300,
    rx: 11.98,
    style: {
      fill: "#e2e3ed"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 20,
    width: 32,
    height: 280,
    rx: 11.98,
    style: {
      fill: "#e2e3ed"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    width: 32,
    height: 300,
    rx: 11.98,
    style: {
      fill: "#e2e3ed"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 165,
    width: 32,
    height: 135,
    rx: 11.98,
    style: {
      fill: "#e2e3ed"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 80,
    width: 32,
    height: 220,
    rx: 11.98,
    style: {
      fill: "#e2e3ed"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    width: 32,
    height: 300,
    rx: 11.98,
    style: {
      fill: "#e2e3ed"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348,
    y: 80,
    width: 32,
    height: 220,
    rx: 11.98,
    style: {
      fill: "#e2e3ed"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 638,
    y: 80,
    width: 32,
    height: 220,
    rx: 11.98,
    style: {
      fill: "#e2e3ed"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 696,
    width: 32,
    height: 300,
    rx: 11.98,
    style: {
      fill: "#e2e3ed"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 754,
    y: 80,
    width: 32,
    height: 220,
    rx: 11.98,
    style: {
      fill: "#e2e3ed"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 206,
    width: 32,
    height: 94,
    rx: 11.98,
    style: {
      fill: "#e2e3ed"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464,
    y: 45,
    width: 32,
    height: 255,
    rx: 11.98,
    style: {
      fill: "#e2e3ed"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 522,
    y: 133,
    width: 32,
    height: 167,
    rx: 11.98,
    style: {
      fill: "#e2e3ed"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 580,
    y: 60,
    width: 32,
    height: 240,
    rx: 11.98,
    style: {
      fill: "#e2e3ed"
    }
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGraphPlaceholderLong, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/graph_placeholder_long.40ad5120.svg";
export { ForwardRef as ReactComponent };